var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnteciparParcelasSensiaBig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7503 35.25H41.1253C42.2024 35.25 43.0837 34.3687 43.0837 33.2917C43.0837 32.2146 42.2024 31.3333 41.1253 31.3333H11.7503C10.6732 31.3333 9.79199 32.2146 9.79199 33.2917C9.79199 34.3687 10.6732 35.25 11.7503 35.25ZM11.7503 25.4583H41.1253C42.2024 25.4583 43.0837 24.5771 43.0837 23.5C43.0837 22.4229 42.2024 21.5417 41.1253 21.5417H11.7503C10.6732 21.5417 9.79199 22.4229 9.79199 23.5C9.79199 24.5771 10.6732 25.4583 11.7503 25.4583ZM21.542 13.7083C21.542 14.7854 22.4232 15.6667 23.5003 15.6667H41.1253C42.2024 15.6667 43.0837 14.7854 43.0837 13.7083C43.0837 12.6313 42.2024 11.75 41.1253 11.75H23.5003C22.4232 11.75 21.542 12.6313 21.542 13.7083Z",
    fill: "#86AA63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5567 13.1515C17.6727 13.2685 17.6727 13.457 17.5567 13.574L12.355 18.8194C12.2377 18.9377 12.0463 18.9377 11.929 18.8194L10.9131 17.795C10.797 17.6779 10.7972 17.4891 10.9134 17.3722L13.7151 14.5548C13.7778 14.4917 13.7331 14.3843 13.6442 14.3843L5.94477 14.3843C5.88954 14.3843 5.84477 14.4291 5.84477 14.4843L5.84477 35.05C5.84477 35.2157 5.71046 35.35 5.54477 35.35L4.11699 35.35C3.95131 35.35 3.81699 35.2157 3.81699 35.05L3.81699 12.6412C3.81699 12.4755 3.95131 12.3412 4.11699 12.3412L13.6442 12.3412C13.7331 12.3412 13.7778 12.2337 13.7151 12.1707L10.9134 9.35331C10.7972 9.2364 10.797 9.04759 10.9131 8.93052L11.929 7.90613C12.0463 7.78778 12.2377 7.78778 12.355 7.90613L17.5567 13.1515Z",
    fill: "#86AA63",
    stroke: "#86AA63",
    strokeWidth: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnteciparParcelasSensiaBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/antecipar_parcelas_sensia_big.c2f06ab50ce9f0a9111ade7cf6a31641.svg";